import { MachineType } from 'models/MachineType';
import { ApiPayload } from 'infrastructure/api/ApiTypes';
import { Api } from 'infrastructure/api/Api'

export const MachineTypeActionType = {
    FETCH_MACHINETYPES: 'FETCH_MACHINETYPES',
    FETCH_MACHINETYPES_SUCCESS: 'FETCH_MACHINETYPES_SUCCESS',
    ADD_MACHINETYPE: 'ADD_MACHINETYPE',
    ADD_MACHINETYPE_SUCCESS: 'ADD_MACHINETYPE_SUCCESS',
    EDIT_MACHINETYPE: 'EDIT_MACHINETYPE',
    EDIT_MACHINETYPE_SUCCESS: 'EDIT_MACHINETYPE_SUCCESS',
    DELETE_MACHINETYPE: 'DELETE_MACHINETYPE',
    DELETE_MACHINETYPE_SUCCESS: 'DELETE_MACHINETYPE_SUCCESS',
    API_ERROR: 'API_ERROR',
};

interface IFetchMachineTypesAction {
    type: typeof MachineTypeActionType.FETCH_MACHINETYPES
    payload: ApiPayload,
    returnPayload: MachineType[],
    meta: {
        isApiCall: boolean
    },
}

interface IAddMachineTypesAction {
    type: typeof MachineTypeActionType.ADD_MACHINETYPE
    payload: ApiPayload,
    returnPayload: MachineType,
    meta: {
        isApiCall: boolean
    },
}

interface IDeleteMachineTypesAction {
    type: typeof MachineTypeActionType.DELETE_MACHINETYPE
    payload: ApiPayload,
    returnPayload: MachineType,
    meta: {
        isApiCall: boolean
    },
}

export type IMachineTypeActions = IFetchMachineTypesAction | IAddMachineTypesAction | IDeleteMachineTypesAction

const baseUrl = 'api/machinetypes';
export class MachineTypeActions {
    public static fetchMachineTypes(token: string): IMachineTypeActions {
        return {
            type: MachineTypeActionType.FETCH_MACHINETYPES,
            payload: Api.fetchApiCall(baseUrl, token, MachineTypeActionType.FETCH_MACHINETYPES_SUCCESS, MachineTypeActionType.API_ERROR),
            returnPayload: [],
            meta: {
                isApiCall: true
            },
        }
    }

    public static addMachineType(token: string, machinetype: MachineType): IMachineTypeActions {
        return {
            type: MachineTypeActionType.ADD_MACHINETYPE,
            payload: Api.postApiCall(baseUrl, token, MachineTypeActionType.ADD_MACHINETYPE_SUCCESS, MachineTypeActionType.API_ERROR, machinetype),
            returnPayload: MachineType.empty(),
            meta: {
                isApiCall: true
            },
        }
    }

    public static editMachineType(token: string, machinetype: MachineType): IMachineTypeActions {
        return {
            type: MachineTypeActionType.EDIT_MACHINETYPE,
            payload: Api.putApiCall(baseUrl + '/' + machinetype.id, token, MachineTypeActionType.EDIT_MACHINETYPE_SUCCESS, MachineTypeActionType.API_ERROR, machinetype),
            returnPayload: MachineType.empty(),
            meta: {
                isApiCall: true
            },
        }
    }

    public static deleteMachineType(token: string, id: number): IMachineTypeActions {
        return {
            type: MachineTypeActionType.DELETE_MACHINETYPE,
            payload: Api.deleteApiCall(baseUrl + '/' + id, token, MachineTypeActionType.DELETE_MACHINETYPE_SUCCESS, MachineTypeActionType.API_ERROR, true),
            returnPayload: MachineType.empty(),
            meta: {
                isApiCall: true
            },
        }
    }

}
